export default __webpack_public_path__ + "drinks.c8ec31fc.svg";